export const TimeArticles_Fr = [
  {
    name: "Jours restants jusqu'à Ramadan 2027",
    link: "/articles-fr/ramadan/",
    description:
      "Quel est le premier jour du Ramadan 2027 dans les calendriers hégirien et grégorien – Quand le Ramadan commence – Décompte jusqu'au mois du Ramadan – Combien de jours restent jusqu'au début du mois béni du Ramadan.",
    showMain: true,
  },
  {
    name: "Jours restants jusqu'à l'Aïd al-Adha 2026",
    link: "/articles-fr/eid-adha/",
    description:
      "Ici, vous trouverez le décompte jusqu'à l'Aïd al-Adha, où vous pourrez découvrir combien de jours restent jusqu'à l'Aïd al-Adha.",
    showMain: true,
  },
  {
    name: "Jours restants jusqu'à l'Aïd al-Fitr 2026",
    link: "/articles-fr/eid-fatr/",
    description:
      "Ici, vous trouverez le décompte jusqu'à l'Aïd al-Fitr, où vous pourrez découvrir combien de jours restent jusqu'à l'Aïd al-Fitr.",
    showMain: true,
  },
  {
    name: "Jours restants jusqu'à la Nuit du mi-Sha'ban 2027",
    link: "/articles-fr/shaban/",
    description:
      "Ici, vous trouverez le décompte jusqu'à la Nuit du mi-Sha'ban, où vous pourrez découvrir combien de jours restent jusqu'à cette nuit bénie.",
    showMain: true,
  },
  {
    name: "Jours restants jusqu'au Nouvel An hégirien 2026",
    link: "/articles-fr/hijri/",
    description:
      "Ici, vous trouverez le décompte jusqu'au Nouvel An hégirien (1er Muharram), où vous pourrez découvrir combien de jours restent jusqu'à cette occasion islamique.",
    showMain: true,
  },
  {
    name: "Jours restants jusqu'à la Fête des Mères 2026",
    link: "/articles-fr/motherday/",
    description:
      "Ici, vous trouverez le décompte jusqu'à la Fête des Mères, où vous pourrez découvrir combien de jours restent jusqu'à cette journée spéciale.",
    showMain: true,
  },
  {
    name: "Jours restants jusqu'à la Coupe du Monde 2026",
    link: "/articles-fr/worldcup/",
    description:
      "Ici, vous trouverez le décompte jusqu'à la Coupe du Monde FIFA 2026, où vous pourrez découvrir combien de jours restent jusqu'au grand rendez-vous footballistique.",
    showMain: true,
  },
  {
    name: "Jours restants jusqu'aux Jeux Olympiques 2028",
    link: "/articles-fr/olympics/",
    description:
      "Ici, vous trouverez le décompte jusqu'aux Jeux Olympiques 2028 à Los Angeles, où vous pourrez découvrir combien de jours restent jusqu'au plus grand événement sportif mondial.",
    showMain: true,
  },
  {
    name: "Jours restants jusqu'à la Coupe d'Asie 2027",
    link: "/articles-fr/asian-cup/",
    description:
      "Ici, vous trouverez le décompte jusqu'à la Coupe d'Asie AFC 2027 au Qatar, où vous pourrez découvrir combien de jours restent.",
    showMain: true,
  },
  {
    name: "Jours restants jusqu'à l'Été 2026",
    link: "/articles-fr/summer/",
    description:
      "Ici, vous trouverez le décompte jusqu'à l'été 2026, où vous pourrez découvrir combien de jours restent jusqu'au début de la saison estivale.",
    showMain: true,
  },
];
